import { Link } from "react-router-dom";

const STEPS = [
  {
    href: "/settings/account",
    title: "Complete your Profile",
    description: "Name, title, and targeting preferences.",
  },
  {
    href: "/settings/workspace-overview",
    title: "Review Workspace overview",
    description: "Invite teammates and confirm org access.",
  },
  {
    href: "/settings/integrations",
    title: "Connect Integrations",
    description: "CRM, calendar, and enrichment credentials.",
  },
  {
    href: "/settings/personas",
    title: "Define Ideal customer profile",
    description: "Personas and ICP segments for People hunt.",
  },
  {
    href: "/settings/content-center",
    title: "Set up AI context center",
    description: "Narrative, prompts, and AI providers.",
  },
] as const;

export function SettingsGettingStartedPage() {
  return (
    <>
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-foreground">Get started</h1>
        <p className="text-muted-foreground">
          Finish these setup steps so your team is ready to find leads and engage.
        </p>
      </header>

      <ol className="flex flex-col gap-3">
        {STEPS.map((step, i) => (
          <li key={step.href}>
            <Link
              to={step.href}
              className="flex items-start gap-4 rounded-lg border border-border bg-card p-4 transition hover:bg-muted/10"
            >
              <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-brand-soft text-sm font-semibold text-brand">
                {i + 1}
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground">{step.title}</p>
                <p className="text-xs text-muted-foreground">{step.description}</p>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </>
  );
}
